module.exports = __webpack_public_path__ + "static/media/changeLogo.d4480e1b.svg";